import React from 'react';
import DownloadAppButtonProperties from './DownloadAppButtonProperties';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import {useStyles} from './DownloadAppButton.style';
import {Box, Tooltip} from '@material-ui/core';
import {useNavigate} from 'react-router-dom';
import AllowAccess from '../../Access/AllowAccess/AllowAccess';

const DownloadAppButton: React.FC<DownloadAppButtonProperties> = ({
    className = '',
}) => {
    const classes = useStyles();
    const navigate = useNavigate();

    const onClick = () => {
        navigate('/app-download');
    }

    return (
        <AllowAccess isRootAgency={true}>
            <Tooltip title={'Descargar app'}>
                <Box className={`${classes.download_app_icon} ${className}`} onClick={onClick}>
                    <InstallMobileIcon/>
                </Box>
            </Tooltip>
        </AllowAccess>
    )
}

export default DownloadAppButton;
